function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M0,222.8V50.4h118l25.7-25.5h139c7.5,0,13.5,6,13.5,13.5v184.4c0,7.5-6,13.5-13.5,13.5l-269.1,0 C6,236.3,0,230.3,0,222.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECF3D",
  d: "M118.1,50.7H0V13.5C0,6,6,0,13.5,0h101.8c10.1,4.4,19.9,12.9,29.3,25.2l0.4,0.6L118.1,50.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0CCBE9",
  d: "M18,19.4v12.8h14.1V19.4H18z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#E0C974",
  points: "123.2,236.3 97.8,236.3 97.9,174.8 99.4,174.5  "
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DAB946",
  points: "270.9,236.3 247.1,236.3 247.3,179.1 248.8,178.8  "
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3CCEF4",
  d: "M220.2,123.7l-143.6,0c-15.7,0-28.4,12.7-28.4,28.4l0,97.9h51.1v-75.5h96.3V250h53.1v-97.9 C248.6,136.4,235.9,123.7,220.2,123.7z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M80.6,19.4H31.5v12.8h49.1V19.4z"
});

function SvgExplorer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 296.1 250",
    enableBackground: "new 0 0 296.1 250",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 130.6435,
    x2: 296.141,
    y2: 130.6435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE897"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBDA62"
    }
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.7d3f4606.svg";
export { ForwardRef as ReactComponent };